import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c('Loader',{attrs:{"is-visible":_vm.loading}}),(!this.$route.path.includes('diagnostico') && _vm.isAuthenticated)?_c('div',{class:{
      'cidades-empreendedoras-header':
        !this.$route.path.includes('diagnostico'),
    }},[_c('img',{attrs:{"src":require("../public/assets/img/sebrae-logo.png"),"width":"100px"}})]):_vm._e(),_c('MenuMobile',{attrs:{"drawer":_vm.drawer},on:{"open":(e) => _vm.drawer = e}}),(!this.$route.path.includes('diagnostico') && _vm.isAuthenticated)?_c(VAppBar,{staticClass:"menu a",class:{
      'degrade-background-sebrae': _vm.isSala,
    },attrs:{"app":""}},[_c('div',{staticClass:"teste d-flex align-center menuPage"},[_c('div',{staticClass:"mobile"},[_c(VAppBarNavIcon,{style:({color: _vm.isCE?'#fff' : '#000' }),on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}})],1),(_vm.isSala)?_c('div',{staticClass:"image"},[_c('selo-logo')],1):_vm._e(),(
        !_vm.isSala &&
        (_vm.isFullAdmin || (_vm.groupsConfig.visualizarLogo && _vm.config.visualizarLogo))
      )?_c('img',{staticClass:"image",staticStyle:{"cursor":"pointer"},attrs:{"src":require(`../public/assets/img/${_vm.logo}`),"width":"100px"},on:{"click":function($event){return _vm.$router.push('/cidade')}}}):_vm._e(),_c('div',{staticClass:"desktop"},[(_vm.isAuthenticated)?_c('Menu',{on:{"logout":_vm.logout}}):_vm._e()],1)]),_c(VSpacer)],1):_vm._e(),_c(VMain,{class:{
      logged: !this.$route.path.includes('diagnostico') && _vm.isAuthenticated,
    }},[_c('router-view')],1),(!this.$route.path.includes('diagnostico'))?_c(VFooter,{staticClass:"app-footer",attrs:{"color":"primary"}},[(
        _vm.isCE &&
        (!_vm.isAuthenticated ||
          _vm.isFullAdmin ||
          (_vm.groupsConfig &&
            _vm.config &&
            _vm.groupsConfig.visualizarLogo &&
            _vm.config.visualizarLogo))
      )?_c('span',[_vm._v("Cidade Empreendedora - SEBRAE / "+_vm._s(this.$store.state.uf))]):_vm._e(),(
        _vm.isSala &&
        (!_vm.isAuthenticated ||
          _vm.isFullAdmin ||
          (_vm.groupsConfig &&
            _vm.config &&
            _vm.groupsConfig.visualizarLogo &&
            _vm.config.visualizarLogo))
      )?_c('span',[_vm._v("Selo de Referência em Atendimento SEBRAE -\n      "+_vm._s(this.$store.state.uf))]):_vm._e(),(
        _vm.isGov &&
        (!_vm.isAuthenticated ||
          _vm.isFullAdmin ||
          (_vm.groupsConfig &&
            _vm.config &&
            _vm.groupsConfig.visualizarLogo &&
            _vm.config.visualizarLogo))
      )?_c('span',[_vm._v("Governança Empreendedora - SEBRAE/"+_vm._s(this.$store.state.uf))]):_vm._e(),(
        _vm.isAT &&
        (!_vm.isAuthenticated ||
          _vm.isFullAdmin ||
          (_vm.groupsConfig &&
            _vm.config &&
            _vm.groupsConfig.visualizarLogo &&
            _vm.config.visualizarLogo))
      )?_c('span',[_vm._v("Agentes Territoriais - "+_vm._s(this.$store.state.uf))]):_vm._e(),(
        _vm.isTur &&
        (!_vm.isAuthenticated ||
          _vm.isFullAdmin ||
          (_vm.groupsConfig &&
            _vm.config &&
            _vm.groupsConfig.visualizarLogo &&
            _vm.config.visualizarLogo))
      )?_c('span',[_vm._v("Sebrae Turismo - "+_vm._s(this.$store.state.uf))]):_vm._e()]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }